export default __webpack_public_path__ + "static/media/clock_poster.f42b562f.svg";